import { gql } from "@apollo/client";

const SUBSCRIPTION_FIELDS = `
  id
  paymentLinkId
  payerEmail
  payerName
  baseAmount
  feeCoverElected
  feeCoverAmount
  chargeAmount
  currency
  status
  interval
  anchorDay
  nextBillingDate
  currentPeriod
  lastBilledDate
  failedAttempts
  lastDeclineCode
  lastDeclineClass
  awaitingPaymentMethod
  cancelAtPeriodEnd
  canceledAt
  cancelReason
  canceledBy
  consentAt
  mandateTextSnapshot
  paymentMethodSummary {
    methodType
    brand
    last4
  }
  createdAt
`;

export const GET_PAYMENT_LINK_SUBSCRIPTIONS = gql`
  query paymentLinkSubscriptions(
    $status: [SubscriptionStatusEnum]
    $paymentLinkId: ID
    $first: Int
    $after: String
    $searchTerm: String
    $sortDirection: SortDirectionEnum
  ) {
    paymentLinkSubscriptions(
      status: $status
      paymentLinkId: $paymentLinkId
      first: $first
      after: $after
      searchTerm: $searchTerm
      sortDirection: $sortDirection
    ) {
      edges {
        cursor
        node {
          ${SUBSCRIPTION_FIELDS}
          paymentLink {
            id
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_PAYMENT_LINK_SUBSCRIPTION = gql`
  query paymentLinkSubscription($id: ID!) {
    paymentLinkSubscription(id: $id) {
      ${SUBSCRIPTION_FIELDS}
      paymentLink {
        id
        name
        url
      }
      contact {
        id
        firstName
        lastName
        businessName
        email
      }
    }
  }
`;

export const GET_SUBSCRIPTION_CHARGES = gql`
  query subscriptionCharges($subscriptionId: ID!) {
    subscriptionCharges(subscriptionId: $subscriptionId) {
      id
      period
      attempt
      amount
      currency
      status
      declineCode
      declineClass
      transactionId
      createdAt
    }
  }
`;

export const CANCEL_PAYMENT_LINK_SUBSCRIPTION = gql`
  mutation cancelPaymentLinkSubscription(
    $id: ID!
    $atPeriodEnd: Boolean
    $reason: String
  ) {
    cancelPaymentLinkSubscription(
      id: $id
      atPeriodEnd: $atPeriodEnd
      reason: $reason
    ) {
      id
      status
      cancelAtPeriodEnd
      canceledAt
    }
  }
`;

export const REVOKE_PAYMENT_LINK_SUBSCRIPTION_ACCESS = gql`
  mutation revokePaymentLinkSubscriptionAccess($id: ID!) {
    revokePaymentLinkSubscriptionAccess(id: $id) {
      id
    }
  }
`;
